import { AnimatePresence } from 'framer-motion'

import { useManagementGetCompanies } from '@apps-common/apis/management/company'
import { CompanyCardSkeleton, CompanyListCard } from '@apps-common/apps/portal/pages/management/components/company'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'

interface IProps {
  searchVal: string
}

export const CompanyInfiniteView: React.FC<IProps> = ({ searchVal }) => {
  const { isLoading, isError, data, isRefetching, refetch } = useManagementGetCompanies({
    name: searchVal
  })

  const loading = isLoading || isRefetching || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[60px]'>
        <PullRefresh loading={isRefetching} callback={() => refetch()} />
        <AnimatePresence>
          <div className='flex flex-col gap-4'>
            {loading && Array.from(Array(20).keys()).map((i) => <CompanyCardSkeleton key={`company-card-skeleton-${i}`} />)}
            {!loading && data?.map((c) => <CompanyListCard key={`company-list-${c.companyId}`} company={c} companies={data} />)}
            {!loading && data && data.length === 0 && <NoResultsCard>No company results.</NoResultsCard>}
          </div>
        </AnimatePresence>
      </LayoutPadding>
    </LayoutContainer>
  )
}
